import { useInsertionEffect } from 'preact/compat'
import { CSSRule } from '@gsc/types'
import { useStyleRegistry } from './StyleRegistryProvider'

export function useRegisterStyle(style: CSSRule): void {
  const registry = useStyleRegistry()

  useInsertionEffect(() => {
    if (!style || !registry) {
      return
    }

    const { id } = style
    registry.add(style)

    return () => registry.remove(id)
  }, [registry, style])
}
